module.exports = __webpack_public_path__ + "static/media/trashcan-primary.98b16fba.svg";